/* globak sdk */
import React from 'react';
import Button from '@material-ui/core/Button';
import Confirm from '../Utils/Confirm';
import Utils from '../Utils/Utils';
import Watch from '../WebRTC/Watch';
import Typography from '@material-ui/core/Typography';


export default class BroadcastInfo extends React.Component {
  state = {
    open: false,
    live: false,
    isBroadcasting: true,
    preview: false
  };

  renew = () => {
    this.refs['confirmRenew'].show()
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  
  handleAgree = async () => {
    let info = await window.sdk.live.renew();
    this.forceUpdate();
    window.sdk.emit('renewStream', info);
    document.location.href = document.location.href
  }
  
  preview = () => {
    
  }
  
  componentDidMount() {
    window.sdk.on('monitorStream', (isLive, isBroadcasting, isRecording) => {
      console.log('monitorStream', isLive, isBroadcasting, isRecording);
      this.setState({
        live: isLive,
        isBroadcasting: isBroadcasting
      })
    });
    window.sdk.live.initMonitoringStream();
  }
  
  async checkWebRTCPreview() {
    
    while(!document.getElementById('webrtc_preview')) {
      await Utils.sleep(1000);
    }
    
    if(!this.watch) {
      this.watcher = new Watch(document.getElementById('webrtc_preview'));
    }
  }

  async activateCDN() {
    if(confirm('Etes vous sur ?')) {
      await sdk.activateCDN()
      document.location.href = document.location.href;
    }
  }

  async desactivateCDN() {
    if(confirm('Etes vous sur ?')) {
      await sdk.desactivateCDN();
      document.location.href = document.location.href;
    }
  }
  
  
  render() {
    
    if(this.state.live)
      this.checkWebRTCPreview();
    
    return (
      <div className={ 'broadcastInfo' }>
        { this.state.live &&
          <div style={{ paddingRight: '5px' }}>
            
              <video id="webrtc_preview" controls width="100%"></video>
            
          </div>
        }
        <div>
          { !this.state.live &&
            <div style={{ color: '#aaa' }}>
              <Typography>
                Pas de flux live actuellement
              </Typography>
            </div>
          }
          { this.state.live &&
            <div style={{ color: '#ff0000' }}>
              <Typography>
                Flux live connecté
              </Typography>
            </div>
          }
          <Confirm ref="confirmRenew" description="En renouvelant le stream vous perdrait toutes les métadonnées déjà enregistré" handleAgree={ this.handleAgree } />
          <Typography variant="body1">
            <b>FMS URL :</b> { window.sdk.live.getStreamInfo().broadcast_url }
          </Typography>
          <Typography variant="body1">
            <b>Stream :</b> { window.sdk.live.getStreamInfo().program.stream_name }<br />
          </Typography>
          <Typography variant="body1">
            <b>Destination stream :</b> { window.sdk.live.getStreamInfo().program.stream_server } 
              { !this.state.isLive &&
                <Button onClick={ this.renew  }>Renouveler</Button>
              }
              { sdk.live.streamUrlCdn != '' ?
               <Button onClick={ this.desactivateCDN }>Désactiver CDN</Button>
               :               
               <Button onClick={ this.activateCDN }>Activer CDN</Button>
              }
          </Typography>

        
          
        </div>
        
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/Manager/BroadcastInfo.js